<i18n src="@/locales/models/order.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/order_item.yml" lang="yaml"></i18n>

<i18n
  src="@/locales/views/service_provider/delivery/managing/edit_order.yml"
  lang="yaml"
></i18n>
<template>
  <go-back-link
    :text="$t('labels.go_back_link')"
    :name="this.routeName('show_order')"
    :params="{
      service_provider_id: service_provider_id,
      delivery_process_id: delivery_process_id,
      id: id,
    }"
  />

  <bread-crumbs :labels="[module_name, delivery_process?.name]" />

  <alert-danger :errors_data="std_err" />

  <div v-if="load_general_data" class="mt-8">
    <div class="panel">
      <div class="panel-header">
        <h3 class="panel-header-title">
          {{ $t("labels.title") }}
        </h3>
      </div>

      <div class="panel-body">
        <div class="space-y-6">
          <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
            <div class="sm:col-span-3">
              <label class="label-form">
                {{ $t("model.order.order_code") }}
              </label>
              <div class="mt-1">
                <input
                  type="text"
                  v-model="order.order_code"
                  :class="['input-text', isInvalid('order_code')]"
                />
              </div>
            </div>

            <div class="sm:col-span-3">
              <label class="label-form">
                {{ $t("model.order.ordered_at") }}
              </label>
              <div class="mt-1">
                <date-form
                  v-model="order.ordered_at"
                  :invalidClass="isInvalid('ordered_at')"
                />
              </div>
            </div>

            <div class="sm:col-span-3">
              <label class="label-form">
                {{ $t("model.order.delivery_process_customer") }}
              </label>
              <div class="mt-1">
                <select-form
                  :options="delivery_process_customers"
                  v-model="order.delivery_process_customer_id"
                  :is_invalid="isInvalidSelect('delivery_process_customer')"
                />
              </div>
            </div>
          </div>

          <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
            <div class="sm:col-span-3">
              <label class="label-form">
                {{ $t("model.order_item.delivery_product") }}
              </label>
              <div class="mt-1">
                <select-form
                  :options="delivery_products"
                  v-model="order.order_items[0].delivery_product_id"
                  :is_invalid="isInvalidSelect('delivery_product')"
                />
              </div>
            </div>

            <div class="sm:col-span-3">
              <label class="label-form">
                {{ $t("model.order_item.quantity") }}
              </label>
              <div class="mt-1">
                <input
                  type="text"
                  v-model="order.order_items[0].quantity"
                  :class="['input-text', isInvalid('quantity')]"
                />
              </div>
            </div>

            <div class="sm:col-span-3">
              <label class="label-form">
                {{ $t("model.order_item.unit_price") }}
              </label>
              <div class="mt-1">
                <input
                  type="text"
                  v-model="order.order_items[0].unit_price"
                  :class="['input-text', isInvalid('unit_price')]"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="panel-footer">
        <div class="panel-footer-actions">
          <white-button
            @click.prevent="goToShowOrder"
            :label="$t('labels.cancel_button')"
          />
          <span class="space-actions"></span>
          <success-button
            v-if="!proc_save_button"
            @click.prevent="update"
            :label="$t('labels.save_button')"
          />
          <success-button-processing v-else :label="$t('labels.save_button')" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Requester from "@/views/service_provider/requesters/delivery/managing/manage_orders.js";
export default {
  name: "SPDeliveryDistributionEditOrder",
  components: {},
  data() {
    return {
      load_general_data: false,
      proc_save_button: false,
      delivery_process: {},
      order: {
        order_code: null,
        ordered_at: null,
        delivery_process_customer_id: null,
      },
      delivery_process_customers: [],
      delivery_products: [],
    };
  },
  props: {
    service_provider_id: { required: true },
    delivery_process_id: { required: true },
    id: { required: true },
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          service_provider_id: this.service_provider_id,
        },
      }).then(() => this.loadData())
    );
  },
  computed: {},
  methods: {
    loadData: async function () {
      await this.fetchDeliveryProcess();
      await this.fetchOrder();
      this.fetchDeliveryProcessCustomers();
      this.fetchDeliveryProducts();
      this.load_general_data = true;
    },

    fetchDeliveryProcess: async function () {
      const response = await Requester.fetchDeliveryProcess(
        this.service_provider_id,
        this.delivery_process_id
      );

      this.delivery_process = response.data;
    },

    fetchOrder: async function () {
      const response = await Requester.fetchOrder(
        this.service_provider_id,
        this.delivery_process_id,
        this.id
      );

      this.order = response.data;
    },

    fetchDeliveryProcessCustomers: async function () {
      const response = await Requester.fetchDeliveryProcessCustomers(
        this.service_provider_id,
        this.delivery_process_id
      );

      this.delivery_process_customers = response.data;
    },

    fetchDeliveryProducts: async function () {
      const response = await Requester.fetchDeliveryProducts(
        this.service_provider_id,
        this.delivery_process_id
      );

      this.delivery_products = response.data;
      this.delivery_products.forEach((product) => {
        product.name = product.crop.name;
      });
    },

    update: async function () {
      this.proc_save_button = true;
      try {
        let response = await Requester.update(
          this.service_provider_id,
          this.delivery_process_id,
          this.id,
          this.order
        );

        this.registerSuccessNotification({
          title: response.data.success_message,
        });
        this.goToShowOrder();
      } catch (error) {
        if (error.response.status == 422) {
          this.loadStandardErrorMessages({
            title: error.response.data.error_title,
            messages: error.response.data.error_messages,
            fields: error.response.data.error_fields,
          });
        }
        this.proc_save_button = false;
      }
    },

    goToShowOrder: function () {
      this.$router.push({
        name: this.routeName("show_order"),
        params: {
          service_provider_id: this.service_provider_id,
          delivery_process_id: this.delivery_process_id,
          id: this.id,
        },
      });
    },
  },
  watch: {},
};
</script>
